import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import logo from "../Assets/Circle Logo 1.png";
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

const Navbar = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { label: "Home", path: "/" },
    { label: "About Us", path: "/about-us" },
    { label: "Our Services", path: "/our-services" },
    { label: "Contact Us", path: "/contact-us" },
  ];

  return (
    <AppBar
      position="fixed"
      sx={{
        bgcolor: "white",
        boxShadow: "none",
        height: "10vh",
        display: "flex",
        justifyContent: "center",
        zIndex: 1200,
      }}
    >
      <Toolbar
        sx={{
          px: { xs: 2, sm: 4, md: "100px" },
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          minHeight: "unset",
        }}
      >
        {/* --- LOGO (clickable to home) --- */}
        <Box
          component={NavLink}
          to="/"
          sx={{
            display: "flex",
            alignItems: "center",
            textDecoration: "none",
          }}
        >
          <Box
            component="img"
            src={logo}
            alt="The Blush Story Logo"
            sx={{
              height: { xs: 40, sm: 50, md: 55 },
              width: "auto",
              cursor: "pointer",
            }}
          />
        </Box>

        {/* --- DESKTOP MENU --- */}
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            justifyContent: "flex-end",
            flexGrow: 1,
          }}
        >
          {navItems.map((item, index) => {
            const isActive = location.pathname === item.path;
            return (
              <Button
                key={item.label}
                component={NavLink}
                to={item.path}
                sx={{
                  color: isActive ? "#EBE4D4" : "#003B1F",
                  fontWeight: 600,
                  fontFamily: "Playfair Display, serif",
                  mx: 2,
                  pr: index < navItems.length - 1 ? "50px" : 0,
                  textTransform: "none",
                  fontSize: { xs: "0.9rem", sm: "1rem", md: "1.1rem" },
                  transition: "0.3s",
                  "&:hover": {
                    bgcolor: "transparent",
                    color: "#EBE4D4",
                  },
                }}
              >
                {item.label}
              </Button>
            );
          })}
        </Box>

        {/* --- MOBILE MENU BUTTON --- */}
        <IconButton
          sx={{
            display: { xs: "flex", md: "none" },
            color: "#003B1F",
          }}
          onClick={() => setDrawerOpen(true)}
        >
          <MenuIcon />
        </IconButton>
      </Toolbar>

      {/* --- MOBILE DRAWER --- */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{
          sx: { width: 220, bgcolor: "#EBE4D4" },
        }}
      >
        <List>
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <ListItem key={item.label} disablePadding>
                <ListItemButton
                  component={NavLink}
                  to={item.path}
                  onClick={() => setDrawerOpen(false)}
                  sx={{
                    bgcolor: isActive ? "#003B1F" : "transparent",
                    "&:hover": {
                      bgcolor: "#003B1F",
                    },
                  }}
                >
                  <ListItemText
                    primary={item.label}
                    primaryTypographyProps={{
                      fontFamily: "Playfair Display, serif",
                      fontWeight: 600,
                      color: isActive ? "#EBE4D4" : "#003B1F",
                      fontSize: "1rem",
                      sx: { transition: "0.3s" },
                    }}
                  />
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </Drawer>
    </AppBar>
  );
};

export default Navbar;
